module.exports = __webpack_public_path__ + "img/layers.076735de.png";